module.exports = __webpack_public_path__ + "img/logo-full-visanet.36cab406.png";